export const divisionsConst = {

    // Divisions types (slugs)
    ministries: 'ministries',
    departures: 'departures',
    organizations: 'organizations',
    events: 'events',
    projects: 'projects',
    campaigns: 'campaigns',
    ebd: 'ebd',
}

// Nomes das divisões em português
export const DIVISION_NAMES = {
    MINISTERIOS: 'Ministérios',
    DEPARTAMENTOS: 'Departamentos',
    ORGANIZACOES: 'Organizações',
    EVENTOS: 'Eventos',
    PROJETOS: 'Projetos',
    CAMPANHAS: 'Campanhas',
    EDUCACAO: 'Educação'
};

// Configuração de estilos por divisão
export const DIVISION_STYLES: { [key: string]: { bgClass: string; iconClass: string; icon: string } } = {
    [DIVISION_NAMES.MINISTERIOS]: {
        bgClass: 'bg-blue-200',
        iconClass: 'text-blue-700',
        icon: 'mat_solid:people'
    },
    [DIVISION_NAMES.DEPARTAMENTOS]: {
        bgClass: 'bg-purple-200',
        iconClass: 'text-purple-700',
        icon: 'mat_solid:business'
    },
    [DIVISION_NAMES.ORGANIZACOES]: {
        bgClass: 'bg-emerald-200',
        iconClass: 'text-emerald-700',
        icon: 'mat_solid:groups'
    },
    [DIVISION_NAMES.EVENTOS]: {
        bgClass: 'bg-amber-200',
        iconClass: 'text-amber-700',
        icon: 'mat_solid:event'
    },
    [DIVISION_NAMES.PROJETOS]: {
        bgClass: 'bg-cyan-200',
        iconClass: 'text-cyan-700',
        icon: 'mat_solid:assignment'
    },
    [DIVISION_NAMES.CAMPANHAS]: {
        bgClass: 'bg-rose-200',
        iconClass: 'text-rose-700',
        icon: 'mat_solid:campaign'
    },
    [DIVISION_NAMES.EDUCACAO]: {
        bgClass: 'bg-indigo-200',
        iconClass: 'text-indigo-700',
        icon: 'mat_solid:school'
    }
};

// Estilo padrão para divisões não mapeadas
export const DEFAULT_DIVISION_STYLE = {
    bgClass: 'bg-gray-200',
    iconClass: 'text-gray-700',
    icon: 'mat_solid:grid_view'
};
